/* eslint-disable react/prop-types */

import 'chartjs-adapter-dayjs-3';
import { getColor } from 'helpers/utils';
import { widgetItemColors } from 'helpers/widgetHelper';
import React from 'react';
import { Line } from 'react-chartjs-2';
import chartTrendline from 'chartjs-plugin-trendline';
import { Chart as ChartJS } from 'chart.js';
ChartJS.register(chartTrendline);

/* LineChartWidget
This widget is used to display a line chart.
The first column of the data is used as the x-axis, and the rest of the columns are used as the y-axis.
*/

function LineChart(props) {
  let columnCount = Object.keys(props.data[0]).length;
  let datasets = [];

  // Handle options
  let showLegend = (props.options && props.options.showLegend && props.options.showLegend === true) ? true : false;
  let trendLineShow = (props.options && props.options.trendLineShow && props.options.trendLineShow === true) ? true : false;
  let trendLineExcludeLast = (props.options && props.options.trendLineExcludeLast && props.options.trendLineExcludeLast === true) ? true : false;
  let pointStyle = (props.options && props.options.pointStyle) ? props.options.pointStyle : 'circle';
  let pointRadius = pointStyle === 'none' ? 0.0 : 4.0;
  let pointHoverRadius = pointStyle === 'none' ? 0.0 : 4.0
  let pointHitRadius = pointStyle === 'none' ? 0.0 : 5.0

  for (let i = 1; i < columnCount; i++) {
    let dt = [];
    props.data.forEach(item => {
      if (Object.keys(item)[i]) {
        dt.push({
          x: item[Object.keys(item)[0]],
          y: item[Object.keys(item)[i]]
        });
      }
    });

    let ds = {
      type: 'line',
      label: Object.keys(props.data[0])[i],
      borderColor: getColor(widgetItemColors[i]),
      borderWidth: 2,
      fill: true,
      data: dt,
      tension: 0.0,
      pointStyle: pointStyle,
      pointRadius: pointRadius,
      pointHoverRadius: pointHoverRadius,
      pointHitRadius: pointHitRadius
    };

    datasets.push(ds);
  }

  // Calculate trendline if needed
  if (trendLineShow) {
    // Get data for first dataset

    let trendLineData = []
    for (let i = 0; i < datasets[0].data.length; i++) {
      if (i >= datasets[0].data.length - 1 && trendLineExcludeLast) {
        continue;
      }
      trendLineData.push(datasets[0].data[i]);
    }

    datasets.push({
      label: 'Trend Line',
      // borderColor: borderColor,
      // borderWidth: borderWidth,
      // backgroundColor: '#0275d8',
      data: trendLineData,
      trendlineLinear: {
        colorMin: 'rgba(255,26,104, 0.5)',
        colorMax: 'rgba(255,26,104, 0.5)',
        lineStyle: 'dashed',
        width: 2,
        projection: true,
        label: {
          color: 'rgba(255,26,104, 1)',
          text: 'Trend Line',
          display: false,
          displayValue: true,
          percentage: true
        },
        legend: {
          text: 'Trend Line',
          borderColor: 'rgba(255,26,104, 1)',
          strokeStyle: 'rgba(255,26,104, 1)',
          fillStyle: 'rgba(255,26,104, 1)',
          lineCap: 'Trend'
        }
      }
    });
  }

  const data = {
    datasets: datasets
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true // Enable tooltips
        //mode: 'nearest', // Show tooltips for all points at the same index
        //intersect: true // Allow tooltips even without intersecting
      },
      legend: {
        display: showLegend,
        labels: {
          color: getColor('gray-500')
        }
      }
    },
    hover: {
      mode: 'nearest', // Adjust hover behavior
      intersect: true // Ensure hover works when intersecting
    },

    scales: {
      x: {
        type: 'time',
        time: {
          tooltipFormat: 'DD HH'
        }
      },
      y: {
        ticks: {
          color: getColor('gray-500')
        },
        grid: {
          color: getColor('gray-300'),
          drawBorder: true
        },
        beginAtZero: true
      }
    }
  };

  //options.scales.y.ticks.precision = 0;

  return <Line data={data} options={options} />;
}

export default function LineChartWidget(props) {
  return <LineChart data={props.data} options={props.options}></LineChart>
}
